import { useContext } from 'react';
import PartnerAuthContext from 'contexts/PartnerAuthContext';

const usePartnerAuth = () => {
    const context = useContext(PartnerAuthContext);
    if (!context) throw new Error('usePartnerAuth must be used inside PartnerAuthProvider');
    return context;
};

export default usePartnerAuth;
